import * as log from 'loglevel';
import {Howl, Howler} from 'howler';
import {game} from '../GameCore';

var sounds: any,
    music: Howl,
    muted: boolean;

/**
 * do initial adding of sounds
 */
export function addSounds()
{
    sounds = {};

    //  create Sound objects for all sounds

    sounds['button-click'] = game.add.audio('button-click');
    sounds['jump'] = game.add.audio('jump');
    sounds['hit-head'] = game.add.audio('hit-head');
    sounds['hit-obstacle'] = game.add.audio('hit-obstacle');
    sounds['level-complete'] = game.add.audio('level-complete');
    sounds['game-over'] = game.add.audio('game-over');
    sounds['bad-power-up'] = game.add.audio('bad-power-up');
    sounds['speed-up'] = game.add.audio('speed-up');
    sounds['points-up'] = game.add.audio('points-up');
    sounds['time-up'] = game.add.audio('time-up');
    sounds['correct-answer'] = game.add.audio('correct-answer');
    sounds['incorrect-answer'] = game.add.audio('incorrect-answer');
    sounds['zingy-sign'] = game.add.audio('zingy-sign');
    sounds['toggle-light-switch'] = game.add.audio('toggle-light-switch');

    //sounds['music-loop'] = game.add.audio('music-loop');

    //  start looping the music

    //game.sound.setDecodedCallback(sounds, () => playLoopingMusic(), null);

}

export function loadMusic()
{
    music = new Howl({
        src: ['assets/audio/music-loop.mp3'],
        autoplay: true,
        loop: true,
        volume: 0.2
        //onend: function() {
        //    console.log('Finished!');
        //}
    });
}



/**
 * play a sound by id
 * @param id
 */
export function playSound(id: string)
{
    log.debug('playing audio:', id);

    sounds[id].play();
}


/**
 * mute all audio
 * @return {boolean}
 */
export function toggleMute() : boolean
{
    log.debug('is muted:', muted);

    if (muted === true)
    {
        game.sound.mute = false;

        Howler.volume(1);

        muted = false;
    }
    else
    {
        game.sound.mute = true;

        //Howler.mute();
        Howler.volume(0);

        muted = true;
    }

    return muted;
}


// WEBPACK FOOTER //
// ./src/ts/game/audio/AudioManager.ts